import React from 'react'

import clsx from 'clsx'

import classes from './Heading.module.scss'

const Heading = ({ as, size = '1', className, children, ...props }) => {
  const Component = as || `h${size}`
  return (
    <Component
      className={clsx(
        'Heading',
        {
          [classes[`is-${size}`]]: size,
        },
        className
      )}
      {...props}
    >
      {children}
    </Component>
  )
}

export default Heading
